import React from "react";

const DazzifyLoading = ({ size = "w-24 h-24" }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8f6fa 0%, #e9e3f7 100%)",
      }}
      aria-busy="true"
      role="status"
    >
      <div
        style={{
          borderRadius: "8px",
          padding: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            borderRadius: 20,
            padding: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="96"
            height="96"
            viewBox="0 0 185 185"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={size + " dazzify-blur-pulse"}
            style={{ borderRadius: "16px", background: "#4B108D" }}
          >
            <rect width="185" height="185" fill="#4B108D" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M89.706 55.0176C90.706 56.0267 90.7727 58.1796 90.5727 74.0571C90.306 94.0386 90.2393 94.5095 85.5724 99.6899C78.9721 107.158 67.7716 107.898 60.1713 101.372C54.371 96.4606 52.3043 87.109 55.5044 80.1121C58.8379 72.7789 64.4382 69.1459 72.3718 69.1459C76.172 69.1459 77.7054 69.4823 80.5055 70.9624C82.439 71.9715 84.1724 72.7789 84.3724 72.7789C84.5724 72.7789 84.7057 69.2131 84.7057 64.8401C84.7057 58.7851 84.9724 56.565 85.7725 55.4212C86.9725 53.672 88.2392 53.5375 89.706 55.0176ZM119.107 69.7514C123.374 71.0296 127.641 74.7299 129.908 79.1029C131.575 82.3323 131.641 83.2069 131.908 93.2985C132.108 102.583 132.041 104.265 131.108 105.005C129.441 106.418 126.708 105.408 126.708 103.39C126.708 101.305 126.641 101.305 122.974 103.457C118.907 105.879 112.307 106.418 107.373 104.736C103.307 103.39 99.1064 99.4881 97.0396 95.3168C95.1062 91.4147 95.1729 82.8705 97.173 79.1702C99.3064 75.1336 103.507 71.4333 107.507 70.0205C111.84 68.5404 114.774 68.4058 119.107 69.7514ZM73.7052 117.451C76.172 120.748 81.7056 124.313 86.3058 125.659C95.0395 128.148 104.907 125.255 110.907 118.528C113.907 115.164 115.707 114.424 117.241 115.971C118.707 117.451 118.041 119.133 114.44 122.901C102.64 135.078 82.7723 135.011 71.3718 122.833C67.1716 118.326 66.7716 115.164 70.4384 115.164C71.3718 115.164 72.6385 116.038 73.7052 117.451ZM66.1715 76.2101C57.9711 80.314 57.1711 92.0876 64.7048 97.5371C69.7717 101.305 75.9053 100.968 80.7055 96.5952C83.7723 93.7695 84.9724 90.6075 84.5724 86.1672C83.7056 77.2865 74.3052 72.1734 66.1715 76.2101ZM101.373 87.58C101.373 81.9959 103.507 78.4302 108.374 75.8737C113.04 73.4517 120.241 75.2682 123.641 79.7085C127.774 85.158 126.708 93.8368 121.508 97.6043C116.507 101.17 110.174 100.901 105.64 96.8643C102.507 94.0386 101.373 91.6839 101.373 87.58Z"
              fill="#3FD6A6"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default DazzifyLoading;
